import React from 'react'
import PropTypes from 'prop-types'
import {
  CloseButton,
  Flex,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'

const TermsModal = ({
  triggerLabel,
  triggerButtonVariant = 'primary',
  modalTitle,
  children,
}) => {
  const {isOpen, onClose, onOpen} = useDisclosure()

  const openModal = (event) => {
    event.stopPropagation()
    event.preventDefault()
    onOpen()
  }

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        as="button"
        variant={triggerButtonVariant}
        fontSize="inherit"
        onClick={openModal}
      >
        {triggerLabel}
      </Link>
      <Modal
        isOpen={isOpen}
        size="xl"
        onClose={onClose}
        preserveScrollBarGap
        scrollBehavior="inside"
      >
        <ModalOverlay zIndex="modal" />
        <ModalContent borderRadius="lg" px="md" py="sm" maxWidth="1000px">
          <ModalHeader fontSize="lg">
            <Flex alignItems="center" justifyContent="space-between">
              <Text textStyle="headline4" textTransform="uppercase">
                {modalTitle}
              </Text>

              <CloseButton onClick={onClose} />
            </Flex>
          </ModalHeader>

          <ModalBody>{children}</ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}

TermsModal.defaultProps = {
  triggerButtonVariant: 'primary',
}

TermsModal.propTypes = {
  triggerLabel: PropTypes.string.isRequired,
  triggerButtonVariant: PropTypes.string,
  modalTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default TermsModal
